import * as React from 'react';
/**
 * The Focus context shares details about the focused day for the keyboard navigation.
 *
 * Access this context from the [[useFocus]] hook.
 */
export var FocusContext = React.createContext(undefined);
//# sourceMappingURL=FocusContext.js.map